import Vue from "vue";
import App from "./App.vue";

// Vuesax Component Framework
import Vuesax from "vuesax";
import VueSweetalert2 from "vue-sweetalert2";

import "sweetalert2/dist/sweetalert2.min.css";
import "material-icons/iconfont/material-icons.css"; //Material Icons
import "vuesax/dist/vuesax.css"; // Vuesax
let colors = {
  primary: '#2B3674',
  success: '#28C76F',
  danger: '#EA5455',
  warning: '#FF9F43',
  dark: '#1E1E1E',
}
Vue.use(Vuesax, { theme: { colors }, rtl: false })
Vue.use(VueSweetalert2);
import { vsButton, vsSelect, vsPopup } from "vuesax";
// axios
import axios from "./axios.js";
Vue.prototype.$http = axios;
Vue.component(vsButton);
Vue.component(vsSelect);
Vue.component(vsPopup);
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
Vue.component('v-select', vSelect)
// Styles: SCSS
import "./assets/scss/main.scss";

// Tailwind
import "@/assets/css/main.css";

// Vue Router
import router from "./router";

//Vue.use(BeakerIcon)
//Vue.component('breaker-icon', BeakerIcon);
// Vuex Store
import store from './store/store'

// i18n
//import i18n from './i18n/i18n'

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from "vue2-hammer";
Vue.use(VueHammer);

// PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";

// Feather font icon
//require('./assets/css/iconfont.css')
import Toasted from "vue-toasted";

let toastOption = {
  theme: "toasted-primary",
  position: "top-right",
  duration: 3000,
  singleton: true,
  action: {
    text: "Cancel",
    onClick: (e, toastObject) => {
      toastObject.goAway(0);
    }
  }
};
Vue.use(Toasted, toastOption);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
